<p i18n>
  See <a class="link-orange" href="https://docs.joinpeertube.org/use/create-upload-video#publish-a-live" target="_blank" rel="noopener noreferrer">the documentation</a>
  to learn how to use the PeerTube live streaming feature.
</p>
